import React,{Component} from 'react';
import {connect} from "react-redux";

import {getManufacturers} from "../../../../redux/actions";
import {getFullMediaUrl} from "../../../../app/static_func";

import './manufacturers.scss';
import mercedesBadge from 'assets/icons/mercedes_badge.svg';
import arrow from 'assets/icons/arrow_down_blue.svg';

class Manufacturers extends Component{

    constructor(props){
        super(props);
        this.state = {
            fullView:false,
            page:0
        }

        this.reloadOnClick = this.reloadOnClick.bind(this);
    }

    componentDidMount() {
        this.props.getManufacturers({page: 0, limit: 10});
        this.setState({page:0});
    }


    reloadOnClick(){
        const fullView = this.state.fullView;
        if (!fullView){
            this.props.getManufacturers({page:this.state.page,limit: 20});
            this.setState({fullView:true});
        }
        else
            this.setState({fullView:false});
    }

    getManufacturersResults(){
        const options = this.props.manufacturers;
        let results = [];
        if (options) {
            options.forEach((item,index) => {
                results.push(
                    <div className='symbol' key={index}>
                        <img src={item.image.path !== '' ? getFullMediaUrl(item.image.path) : mercedesBadge}
                             alt={item.image.alt}
                             className='symbolImg'/>
                    </div>)
            });
        }

        return results;
    }

    render(){
        const isLaptopOrDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop_large';


        return(
            <section className='manufacturers'>
                <div className='topTitle'>
                    <span className='topSpan'>{this.props.text['manufacturers_top_span']}</span>
                    <div className='divider'/>
                    <h2 className='topHeader'>{this.props.text['manufacturers_top_header']}</h2>
                </div>
                <div className={'symbolsGrid ' + (this.state.fullView ? 'full' : '')}>
                    {this.getManufacturersResults()}
                </div>
                {!isLaptopOrDesktop &&
                <span className='moreBrands' onClick={() => this.reloadOnClick()}>{this.state.fullView ? this.props.text['manufacturers_less'] : this.props.text['manufacturers_more'] }</span>
                }
                {isLaptopOrDesktop &&
                <div className='extraContainer'>
                    <span className='moreBrands'>{this.state.fullView ? this.props.text['manufacturers_less'] : this.props.text['manufacturers_more'] }</span>
                    <img className={'arrowIcon ' + (this.state.fullView ? 'rotate' : '')} src={arrow} alt='\' onClick={() => this.reloadOnClick()}/>
                </div>
                }
            </section>
        )
    }
}


//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        manufacturers: store.data.ManufactureresResults,
        text: store.config.Translations,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
        getManufacturers:(payload) => dispatch(getManufacturers(payload)),
    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Manufacturers);
